import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';
import DashCard from '../Common/DashCard';


class SigningAgents extends React.Component {
  
  state={
    userId:functions.sessionGuard(),
    value:'...'
  }
  async componentDidMount()
  {
    await this.requestRecord();
    this.timer = setTimeout(this.func=async()=> {
      await this.requestRecord();
      this.timer = setTimeout(this.func, 2000); // (*)
    }, 2000);
  }

  componentWillUnmount()
  {
    clearTimeout(this.timer)
  }

  requestRecord=async()=>{
    const server_response=await ajax.countDailyAgents(this.state.userId);
    if(server_response.status==="OK")
    {
      this.setState({
        value:server_response.details.total_c
      })
    }
  }

  render(){
    
      return (
        <DashCard 
            title="Signing Agents"
            value={this.state.value}
            caption="Agents with customers"
            icon={"fas fa-globe text-info"}
            />

      );
    
 
  }
}

export default SigningAgents;